import axios from "axios";
import { API_URL } from "../variables";

// Action Types
export const FETCH_ROUTINES_REQUEST = "FETCH_ROUTINES_REQUEST";
export const FETCH_ROUTINES_SUCCESS = "FETCH_ROUTINES_SUCCESS";
export const FETCH_ROUTINES_FAILURE = "FETCH_ROUTINES_FAILURE";

export const FETCH_ROUTINE_DETAIL_REQUEST = "FETCH_ROUTINE_DETAIL_REQUEST";
export const FETCH_ROUTINE_DETAIL_SUCCESS = "FETCH_ROUTINE_DETAIL_SUCCESS";
export const FETCH_ROUTINE_DETAIL_FAILURE = "FETCH_ROUTINE_DETAIL_FAILURE";

export const FETCH_SKIN_TYPES_REQUEST = "FETCH_SKIN_TYPES_REQUEST";
export const FETCH_SKIN_TYPES_SUCCESS = "FETCH_SKIN_TYPES_SUCCESS";
export const FETCH_SKIN_TYPES_FAILURE = "FETCH_SKIN_TYPES_FAILURE";

export const FETCH_POPULAR_ROUTINES_REQUEST = "FETCH_POPULAR_ROUTINES_REQUEST";
export const FETCH_POPULAR_ROUTINES_SUCCESS = "FETCH_POPULAR_ROUTINES_SUCCESS";
export const FETCH_POPULAR_ROUTINES_FAILURE = "FETCH_POPULAR_ROUTINES_FAILURE";

export const INCREMENT_ROUTINE_USAGE_SUCCESS = "INCREMENT_ROUTINE_USAGE_SUCCESS";

// Fetch all routines with optional filtering
export const fetchRoutines = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ROUTINES_REQUEST });
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.per_page) queryParams.append("per_page", params.per_page);
    if (params.skin_type_id) queryParams.append("skin_type_id", params.skin_type_id);
    if (params.search) queryParams.append("search", params.search);
    queryParams.append("status", "published");

    const response = await axios.get(
      `${API_URL}/api/products/routines?${queryParams.toString()}`
    );
    dispatch({
      type: FETCH_ROUTINES_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_ROUTINES_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Fetch single routine by ID or slug
export const fetchRoutineDetail = (routineId) => async (dispatch) => {
  dispatch({ type: FETCH_ROUTINE_DETAIL_REQUEST });
  try {
    const response = await axios.get(
      `${API_URL}/api/products/routines/${routineId}`
    );
    dispatch({
      type: FETCH_ROUTINE_DETAIL_SUCCESS,
      payload: response.data.result,
    });
    return response.data.result;
  } catch (error) {
    dispatch({
      type: FETCH_ROUTINE_DETAIL_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Fetch all skin types
export const fetchSkinTypes = () => async (dispatch) => {
  dispatch({ type: FETCH_SKIN_TYPES_REQUEST });
  try {
    const response = await axios.get(`${API_URL}/api/products/skin-types`);
    dispatch({
      type: FETCH_SKIN_TYPES_SUCCESS,
      payload: response.data.results || response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: FETCH_SKIN_TYPES_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Fetch popular routines
export const fetchPopularRoutines = (limit = 4) => async (dispatch) => {
  dispatch({ type: FETCH_POPULAR_ROUTINES_REQUEST });
  try {
    const response = await axios.get(
      `${API_URL}/api/products/routines/popular?limit=${limit}`
    );
    dispatch({
      type: FETCH_POPULAR_ROUTINES_SUCCESS,
      payload: response.data.routines,
    });
    return response.data.routines;
  } catch (error) {
    dispatch({
      type: FETCH_POPULAR_ROUTINES_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Increment routine usage count
export const incrementRoutineUsage = (routineId) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/products/routines/increment-usage`,
      { routine_id: routineId }
    );
    if (response.data.status === "success") {
      dispatch({
        type: INCREMENT_ROUTINE_USAGE_SUCCESS,
        payload: routineId,
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error incrementing routine usage:", error);
  }
};

